import i18n from 'i18n/config';
import Box from 'UIKit/Box';

import styles from './verifyFaceAuthList.module.scss';

const twoFaFaceAuthFixedT = i18n.getFixedT(null, 'auth', 'twoFaFaceAuth');

const list = [
  {
    title: twoFaFaceAuthFixedT('selfieStepTitle'),
    description: twoFaFaceAuthFixedT('selfieStepDescription'),
  },
  {
    title: twoFaFaceAuthFixedT('reset2faStepHeading'),
    description: twoFaFaceAuthFixedT('reset2faStepDescription'),
  },
  {
    title: twoFaFaceAuthFixedT('confirmStepHeading'),
    description: twoFaFaceAuthFixedT('confirmStepDescription'),
  },
];

const textHeading = twoFaFaceAuthFixedT('verifyIdentityToReset2fa');

const textSubHeading = twoFaFaceAuthFixedT('faceAuthSubHeading');

const VerifyFaceAuthList = () => {
  return (
    <Box className={styles.body}>
      <Box as="h2" className={styles.heading}>
        {textHeading}
      </Box>
      <Box>
        <Box as="h4" className={styles.subHeading}>
          {textSubHeading}{' '}
        </Box>
        <Box as="ol">
          {list.map(item => (
            <Box as="li" key={item.title} className={styles.listItem}>
              <Box as="span" className={styles.listItemHeading}>
                {item.title} - &nbsp;
              </Box>
              <Box as="span" className={styles.listItemDescription}>
                {item.description}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export { VerifyFaceAuthList };
